<div class="py-20 bg-light">
  <div class="container mx-auto px-6 max-w-md">
    <div class="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-lg dark:shadow-slate-900/50 border">
      <!-- En-tête -->
      <div class="text-center mb-6">
        <h2 class="text-3xl font-bold text-secondary">
          Réinitialiser votre mot de passe
        </h2>
        <p class="text-center text-gray-500 dark:text-gray-400 mt-2">
          Entrez votre email pour recevoir un lien de réinitialisation.
        </p>
      </div>

      <!-- Message de succès -->
      @if (successMessage) {
        <div
          class="bg-green-100 dark:bg-green-900/30 border-l-4 border-green-500 text-green-700 dark:text-green-300 p-4 mb-6"
          role="alert"
          >
          <p class="font-semibold mb-2">✅ Demande reçue</p>
          <p>{{ successMessage }}</p>
          <p class="text-sm mt-2 text-green-600 dark:text-green-400">
            Vérifiez votre boîte de réception (et vos spams).
          </p>
        </div>
      }

      <!-- Message d'erreur -->
      @if (errorMessage) {
        <div
          class="bg-red-100 dark:bg-red-900/30 border-l-4 border-red-500 text-red-700 dark:text-red-300 p-4 mb-6"
          role="alert"
          >
          <p>{{ errorMessage }}</p>
        </div>
      }

      <!-- Formulaire (masqué si succès) -->
      @if (!successMessage) {
        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="onSubmit()"
          >
          <div class="mb-6">
            <label for="email" class="block text-gray-700 dark:text-gray-300 font-semibold mb-2"
              >Email</label
              >
              <input
                type="email"
                id="email"
                formControlName="email"
                class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="vous@exemple.com"
                [disabled]="isLoading"
                />
              <!-- Erreurs de validation email -->
              @if (
                forgotPasswordForm.get('email')?.invalid &&
                forgotPasswordForm.get('email')?.touched
                ) {
                <p class="text-red-500 text-sm mt-1">
                  @if (forgotPasswordForm.get('email')?.errors?.['required']) {
                    <span
                      >L'email est requis.</span
                      >
                    }
                    @if (forgotPasswordForm.get('email')?.errors?.['email']) {
                      <span
                        >Veuillez entrer un email valide.</span
                        >
                      }
                    </p>
                  }
                </div>
                <button
                  type="submit"
                  [disabled]="forgotPasswordForm.invalid || isLoading"
                  class="w-full bg-purple-600 text-white font-semibold text-lg py-3 rounded-lg hover:bg-purple-700 transition-colors shadow-md dark:shadow-slate-900/50 disabled:bg-purple-300 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                  @if (isLoading) {
                    <svg
                      class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span>Envoi en cours...</span>
                  } @else {
                    <span>Envoyer le lien de réinitialisation</span>
                  }
                </button>
              </form>
            }

            <!-- Actions après succès -->
            @if (successMessage) {
              <div class="flex gap-3">
                <button
                  (click)="goToLogin()"
                  class="w-full bg-purple-600 text-white font-semibold text-lg py-3 rounded-lg hover:bg-purple-700 transition-colors shadow-md dark:shadow-slate-900/50 disabled:bg-purple-300 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                  Retour à la connexion
                </button>
              </div>
            }

            <!-- Lien retour connexion (avant succès) -->
            @if (!successMessage) {
              <p class="text-center text-gray-600 dark:text-gray-400 mt-6">
                Vous vous souvenez de votre mot de passe ?
                <a
                  routerLink="/login"
                  class="text-primary hover:underline font-semibold"
                  >Connectez-vous</a
                  >
                </p>
              }
            </div>
          </div>
        </div>
